// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      id: string,
    },
  },
  context: {
    parentId?: ?string,
  },
};

const mutation = graphql`
  mutation DeleteAttachmentMutation($input: DeleteAttachmentInput!) {
    deleteAttachment(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: ({ context, ...options }: MutationOptions) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_DELETE',
          parentID: ROOT_ID,
          connectionKeys: [
            {
              key: 'Attachments_attachments',
              filters: {
                parentId: context.parentId,
              },
            },
          ],
          pathToConnection: [ROOT_ID, 'attachments'],
          deletedIDFieldName: 'deletedId',
        },
      ],
    });
  },
};
